import "../styles/Dashboard.css";
import React, { useState, useEffect } from "react";
import config from "../config";
const backendUrl = process.env.REACT_APP_BACKEND_URL;



const Dashboard = ({ selection, environment }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("india"); 


  // DESK FIELDS
  const [URL, setURL] = useState("");
  const [Username, setUname] = useState("");
  const [Password, setUpassword] = useState("");
  const [Branch, setBranch] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [nuraId, setNuraId] = useState("");

  const [statusMessage, setStatusMessage] = useState("");
  const [isRunning, setIsRunning] = useState(false);
  const [reportLinks, setReportLinks] = useState([]);

  // CLEAR message/data when platform changes
  useEffect(() => {
    setStatusMessage("");
    setReportLinks([]);
    setSelectedCountry("india");

    setUsername("");
    setPassword("");

    setFirstname("");
    setUname("");
    setUpassword("");
    setBranch("");
    setURL("");
    setLastname("");
    setEmail("");
    setPhone("");
    setNuraId("");
  }, [selection.platform]);

  const handleRun = async () => {
    const isDesk = selection.platform === "Desk";
    const countryConfig = config[selectedCountry] || config.india;

    const validInput = isDesk
      ? (URL || countryConfig?.UATUrl) && (Username || countryConfig?.Username) && (Password || countryConfig?.Password)
      : username && password;

    if (!selection.platform || selection.tests.length === 0 || !validInput) {
      alert("Fill all fields and select at least one test case.");
      return;
    }

    setIsRunning(true);
    setStatusMessage(
      `<span style="color: rgba(6, 147, 227, 1);">Running ${selection.platform} tests: ${selection.tests.join(", ")}</span>`
    );

    setReportLinks([]);

    try {
      const capitalize = (s) => (typeof s === "string" && s.length > 0) ? s.charAt(0).toUpperCase() + s.slice(1) : s;
      
    const payload = {
      platform: selection.platform,
      environment,
      testCases: selection.tests,
      selectedCountry,
      credentials: isDesk
          ? {
              url: URL || countryConfig?.UATUrl,
              username: Username || countryConfig?.Username,
              password: Password || countryConfig?.Password,
              branch: Branch || countryConfig?.UATBranches,
              nuraId: nuraId || countryConfig?.nuraID,
              email: email || countryConfig?.user?.email,
              phone: phone || countryConfig?.user?.phone,
              firstname: capitalize(firstname || countryConfig?.user?.firstname),
              lastname: capitalize(lastname || countryConfig?.user?.lastname), 

            }
          : { username, password },
        environmentDetails: {
          ...countryConfig,
          ...(isDesk
            ? {
                UATUrl: URL || countryConfig?.UATUrl,
                Username: Username || countryConfig?.Username,
                Password: Password || countryConfig?.Password,
                UATBranches: Branch || countryConfig?.UATBranches,
                nuraID: nuraId || countryConfig?.nuraID,
                email: email || countryConfig?.user?.email,
                phone: phone || countryConfig?.user?.phone,
                AdvancedSearchEmail: email || countryConfig?.AdvancedSearchEmail,
                AdvancedSearchPhone: phone || countryConfig?.AdvancedSearchPhone,
                CreditBillUser: firstname || countryConfig?.CreditBillUser,
                AdvancedSearchFirstName: firstname || countryConfig?.AdvancedSearchFirstName,
                AdvancedSearchlastName: lastname || countryConfig?.AdvancedSearchlastName,
                user: {
                  firstname: capitalize(firstname || countryConfig?.user?.firstname),
                  lastname: capitalize(lastname || countryConfig?.user?.lastname),
                },
              }
            : {}),
      },
      };

      const response = await fetch(`${backendUrl}/run-test`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
    console.log("Backend response:", data);

    if (!response.ok) {
      setStatusMessage(`❌ Error: ${data.message}`);
      setIsRunning(false);
      return;
    }

    const timestamp = new Date().toLocaleTimeString();

    // ✔ Extract results from backend
    const results = Array.isArray(data.results) ? data.results : [];

    const hasFailure = results.some(r => r.status.includes("❌"));
    const hasSkipped = results.some(r => r.status.includes("⚠️"));

    let statusColor = hasFailure ? "red" : hasSkipped ? "orange" : "green";
    let statusIcon = hasFailure ? "❌" : hasSkipped ? "⚠️" : "✅";
    let statusLabel =
      hasFailure
        ? "Some tests failed"
        : hasSkipped
        ? "Some tests skipped"
        : "All tests passed";

    setStatusMessage(
      `<span style="color:${statusColor};">${statusIcon} ${statusLabel} at ${timestamp}</span>`
    );

    // ✔ SET REPORT LINKS
    if (Array.isArray(data.reports)) {
      // Clean path: replace backslashes → forward slashes
      const normalizedReports = data.reports.map(r =>
        r.replace(/\\/g, "/")
      );
      setReportLinks(normalizedReports);
    } else {
      setReportLinks([]);
    }

  } catch (err) {
    console.error("Run-test error:", err);
    setStatusMessage("❌ Failed to connect to server.");
  } finally {
    setIsRunning(false);
  }
  };

  return (
    <div className="main-content">
      <div className="welcome-box">
        <h2 className="welcome-heading">Welcome to the Automated Testing Platform</h2>
        <p className="welcome-text">Select a test case from the menu and run automation.</p>

        {/* DESK INPUT FIELDS */}
        {selection.platform === "Desk" && (
          <>
            <h4>Enter Desk Customer Details</h4>
            {/* Add country selector */}
            <div style={{ marginBottom: 12 }}>
              <label style={{ marginRight: 8 }}><strong>Country</strong></label>
              <select value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)} className="input-field">
                {/* if your config.js is single object, only "india" will exist — adjust options to match config keys */}
                <option value="india">India</option>
                <option value="mongolia">Mongolia</option>
                <option value="vietnam">Vietnam</option>
              </select>
            </div>
            <input
              type="text"
              placeholder="URL"
              value={URL}
              onChange={(e) => setURL(e.target.value)}
              className="input-field"
            />
            <input
              type="text"
              placeholder="Username"
              value={Username}
              onChange={(e) => setUname(e.target.value)}
              className="input-field"
            />
            <input
              type="text"
              placeholder="password"
              value={Password}
              onChange={(e) => setUpassword(e.target.value)}
              className="input-field"
            />
            <input
              type="text"
              placeholder="Branch"
              value={Branch}
              onChange={(e) => setBranch(e.target.value)}
              className="input-field"
            />
            <input
              type="text"
              placeholder="First Name"
              value={firstname}
              onChange={(e) => setFirstname(e.target.value)}
              className="input-field"
            />

            <input
              type="text"
              placeholder="Last Name"
              value={lastname}
              onChange={(e) => setLastname(e.target.value)}
              className="input-field"
            />

            <input
              type="text"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-field"
            />

            <input
              type="text"
              placeholder="Phone Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="input-field"
            />

            <input
              type="text"
              placeholder="Nura ID"
              value={nuraId}
              onChange={(e) => setNuraId(e.target.value)}
              className="input-field"
            />
          </>
        )}

        {/* WEBSITE CREDENTIALS */}
        {selection.platform === "Website" && (
          <>
            <h4>Enter Website Credentials</h4>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="input-field"
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
            />
          </>
        )}

        {/* APP REQUIREMENTS SECTION */}
        {selection.platform === "App" && (
          <>
            <h4>📱 App Automation Requirements</h4>
            <a href={`${backendUrl}/utils/automation-requirements.txt`} download>
              Download requirements.txt
            </a>
            <br />
            <a href={`${backendUrl}/utils/run_android_test.bat`} download>
              Run BAT file (Windows)
            </a>
            <br />
            <a href={`${backendUrl}/utils/run_android_test.sh`} download>
              Run SH file (Linux)
            </a>
          </>
        )}

        {/* RUN BUTTON */}
        {selection.platform !== "App" && (
          <button
            className="run-button"
            onClick={handleRun}
            disabled={
              !selection.platform ||
              selection.tests.length === 0 ||
              isRunning ||
              (selection.platform === "Desk"
                ? !(firstname && lastname && email && phone && nuraId && Branch && URL && Username && Password)
                : !(username && password))
            }
          >
            {isRunning ? "Running..." : `Run ${selection.platform}`}
          </button>
        )}

        {/* STATUS MESSAGE */}
        {statusMessage && (
          <p
            className="status-message"
            dangerouslySetInnerHTML={{ __html: statusMessage }}
          />
        )}

        {/* REPORT LINKS */}
        {Array.isArray(reportLinks) && reportLinks.length > 0 && (
          <div className="report-links">
            <h4>🧾 View Reports</h4>
            <ul>
              {reportLinks.map((file, index) => (
                <li key={index}>
                  <a
                      href={`${backendUrl}/${file}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                    {file.replace(/^reports\//, "")}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
